import UpdateTicker from "./components/UpdateTicker";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RankBoard from "./components/RankBoard";
import FlashFeed from "./components/FlashFeed";
import TopicWall from "./components/TopicWall";
import FieldGrid from "./components/FieldGrid";
import SubmitGuide from "./components/SubmitGuide";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <UpdateTicker />
      <Navbar />
      <main>
        <Hero />
        <RankBoard />
        <FlashFeed />
        <TopicWall />
        <FieldGrid />
        <SubmitGuide />
      </main>
      <Footer />
    </div>
  );
}